import { HorizontalTabs } from "@via/components/tabs.tsx";
import { ROUTES } from "@via/utils/constants.tsx";
import type { JSX } from "react";
import { useNavigate } from "react-router-dom";

type PipelinesTab = "Pipelines" | "Processes";

interface PipelinesTabBarProps {
  active: "pipelines" | "processes";
}

export default function PipelinesTabBar({
  active,
}: PipelinesTabBarProps): JSX.Element {
  const navigate = useNavigate();

  return (
    <HorizontalTabs<PipelinesTab>
      buttonIdPrefix="pipelines"
      activeTab={active === "pipelines" ? "Pipelines" : "Processes"}
      onTabChange={tab =>
        navigate(
          tab === "Processes" ? ROUTES.PIPELINE_PROCESSES : ROUTES.PIPELINES
        )
      }
      options={[{ name: "Pipelines" }, { name: "Processes" }]}
    />
  );
}
